import { useStore } from "reactflow";
import styled from "styled-components";
import { theme } from "../../../styles/theme";

// Renders Figma-style "smart guide" lines while a node is being Shift-dragged
// into alignment with another node (see handleNodeDrag in view/index.tsx).
// Coordinates come in as flow-space positions and are converted to screen
// pixels using the same [tx, ty, zoom] transform React Flow itself uses —
// this component renders as a plain sibling of <Background>/<MiniMap>, which
// sit in screen space already (unaffected by the pan/zoom viewport transform).
export function AlignmentGuides({ x, y }: { x: number | null; y: number | null }) {
   const transform = useStore((s) => s.transform);
   const [tx, ty, zoom] = transform;

   if (x === null && y === null) return null;

   const screenX = x !== null ? x * zoom + tx : null;
   const screenY = y !== null ? y * zoom + ty : null;

   return (
      <Main>
         {screenX !== null ? <div className="vertical" style={{ left: screenX }} /> : null}
         {screenY !== null ? <div className="horizontal" style={{ top: screenY }} /> : null}
      </Main>
   );
}

const Main = styled.div`
   position: absolute;
   inset: 0;
   pointer-events: none;
   z-index: 5;

   .vertical {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 0;
      border-left: 1px dashed ${theme.colors.primary};
   }
   .horizontal {
      position: absolute;
      left: 0;
      right: 0;
      height: 0;
      border-top: 1px dashed ${theme.colors.primary};
   }
`;
